var idCart = "https://shopfront-cdn.tekoapis.com/static/66485d061b21552d.svg";

export { idCart as default };
